import { useState } from 'react'
import { ConnectionsTabItem, ConnectionsTabs } from '../..'

type HookProps = {
  tab?: ConnectionsTabItem
}

const useConnectionsModal = ({ tab = ConnectionsTabs.first }: HookProps) => {
  const [activeTab, setActiveTab] = useState<ConnectionsTabItem>(tab)
  const [searchQuery, setSearchQuery] = useState('')

  return {
    activeTab,
    setActiveTab,
    searchQuery,
    setSearchQuery,
  }
}

export default useConnectionsModal
